module.exports = __webpack_public_path__ + "static/media/flag-sweden.fe725901.svg";